import React, { useEffect, useState } from 'react'
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar';
import SelectDropDown from '../../../components/elements/SelectDropDown';
import { VariableStatements } from './VariableStatements';
import { filterStatement, getPageListStatement } from '../../../store/Actions/ActionStatements';
import { useSelectorCustom } from '../../../components/general/general-component/abstruct-component/useSelectorCustom';

function FilterStatements({ translate, noPadding, bigTitle }) {
    const { dispatch, navigate, langLocal } = AbstructVar()
    const { state, setStateCustom, setLoad, handleChangeDate } = VariableStatements();
    const [projectId, setProjectId] = useState('')
    const { profileDetails, page_list_statement, loadingPageListStatement } = useSelectorCustom()
    useEffect(() => {
        dispatch(getPageListStatement())
    }, [])
    const Filter = (e) => {
        e.preventDefault()
        dispatch(filterStatement(state.project_id, state.user_id, state.account_id, state.date, state.search_value, setLoad))
    }
    return (
        <div className='filteruser ' dir={langLocal === 'ar' ? "rtl" : "ltr"} style={noPadding && { padding: "4px 0px 10px 0px" }} >
            {
                bigTitle ? <h2 className="main_title_color" >{translate('search_filter')}</h2> :
                    <h3>{translate('search_filter')}</h3>
            }
            <div className='div_filter' style={{ marginTop: '0px' }} >
                <div style={{ marginTop: "15px" }} className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-24`} >
                    <input type='text' className={`input_filter1 ${langLocal === 'ar' ? "margin_left_25" : "margin_right_25"} `} placeholder={translate('search')} onChange={(e) => setStateCustom('search_value', e.target.value)} />
                </div>
                <div style={{ marginTop: "15px" }} className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-24`} >
                    <input type='date' className={`input_filter1 ${langLocal === 'ar' ? "margin_left_25" : "margin_right_25"} `} placeholder={translate('date')} onChange={(e) => setStateCustom('date', e.target.value)} />
                </div>
                <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-24`} style={{ fontSize: "14px" }} >
                    <SelectDropDown
                        placeholder={translate('project')}
                        options={page_list_statement?.projects?.map((type) => ({
                            label: type?.name, value: type?.id
                        }))}
                        varr={state?.project_id}
                        setVarr={(value) => setStateCustom('project_id', value)}
                    />
                </div>
                {
                    profileDetails?.role === 'accountant' ? <></>: <>
                        <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-24`} style={{ fontSize: "14px" }} >
                            <SelectDropDown
                                placeholder={translate('users')}
                                options={page_list_statement?.users?.map((user) => ({
                                    label: user?.name, value: user?.id
                                }))}
                                varr={state?.user_id}
                                setVarr={(value) => setStateCustom('user_id', value)}
                            />
                        </div>
                        <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-24`} style={{ fontSize: "14px" }} >
                            <SelectDropDown
                                placeholder={translate('account')}
                                options={page_list_statement?.accounts?.map((account) => ({
                                    label: account?.name, value: account?.id
                                }))}
                                varr={state?.account_id}
                                setVarr={(value) => setStateCustom('account_id', value)}
                            />
                        </div>
                    </>
                }

                <button className='btn_filter' onClick={Filter} style={{ marginBottom: "0px" }} >
                    {
                        state.Load ? "Loading ..." : `${translate('filter')}`
                    }
                </button>
            </div>
        </div>
    )
}

export default FilterStatements


